import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query channelTeamRequestTypeTimeouts {
  channelTeamRequestTypeTimeouts {
    id
    autoholdChatTimeout
    autocloseMsgTimeout
    autocloseChatTimeout
    inactiveChatAutocloseMsg
    team {
      id
      name
    }
    requestType{
      id
      name
    }
    channel {
      id
      name
    }
  }
}`;

async function getTimeouts() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.channelTeamRequestTypeTimeouts);
}

export default getTimeouts;
